"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDeleteDialog = exports.useDeleteDialogProps = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var model_1 = require("../../model");
var deleteMessages = react_intl_1.defineMessages({
    alertsAndEmails: {
        id: "deleteDashboardDialog.alertsAndEmailsMessage",
    },
    alerts: {
        id: "deleteDashboardDialog.alertsMessage",
    },
    emails: {
        id: "deleteDashboardDialog.emailsMessage",
    },
    drills: {
        id: "deleteDashboardDialog.drillMessage",
    },
});
/**
 * @internal
 */
function useDeleteDialogProps() {
    var dispatch = model_1.useDashboardDispatch();
    var onCancel = react_1.useCallback(function () { return dispatch(model_1.uiActions.closeDeleteDialog()); }, [dispatch]);
    var onDelete = react_1.useCallback(function () {
        return model_1.dispatchAndWaitFor(dispatch, model_1.deleteDashboard()).finally(function () {
            dispatch(model_1.uiActions.closeDeleteDialog());
        });
    }, [dispatch]);
    var isVisible = model_1.useDashboardSelector(model_1.selectIsDeleteDialogOpen);
    var isKpiWidgetEnabled = model_1.useDashboardSelector(model_1.selectSupportsKpiWidgetCapability);
    var isScheduleEmailsEnabled = model_1.useDashboardSelector(model_1.selectEnableKPIDashboardScheduleRecipients);
    var isDrillToDashboardEnabled = model_1.useDashboardSelector(model_1.selectEnableKPIDashboardDrillToDashboard);
    return {
        isVisible: isVisible,
        isKpiWidgetEnabled: isKpiWidgetEnabled,
        isScheduleEmailsEnabled: isScheduleEmailsEnabled,
        isDrillToDashboardEnabled: isDrillToDashboardEnabled,
        onCancel: onCancel,
        onDelete: onDelete,
    };
}
exports.useDeleteDialogProps = useDeleteDialogProps;
/**
 * @internal
 */
exports.DefaultDeleteDialog = function (props) {
    var isVisible = props.isVisible, isKpiWidgetEnabled = props.isKpiWidgetEnabled, isScheduleEmailsEnabled = props.isScheduleEmailsEnabled, isDrillToDashboardEnabled = props.isDrillToDashboardEnabled, onDelete = props.onDelete, onCancel = props.onCancel;
    var intl = react_intl_1.useIntl();
    if (!isVisible) {
        return null;
    }
    var messages = compact_1.default([
        isKpiWidgetEnabled && isScheduleEmailsEnabled && deleteMessages.alertsAndEmails,
        isKpiWidgetEnabled && !isScheduleEmailsEnabled && deleteMessages.alerts,
        !isKpiWidgetEnabled && isScheduleEmailsEnabled && deleteMessages.emails,
        isDrillToDashboardEnabled && deleteMessages.drills,
    ]);
    return (react_1.default.createElement(sdk_ui_kit_1.ConfirmDialog, { onCancel: onCancel, onSubmit: onDelete, isPositive: false, className: "s-dialog s-delete_dashboard_dialog", headline: intl.formatMessage({ id: "deleteDashboardDialog.headline" }), cancelButtonText: intl.formatMessage({ id: "cancel" }), submitButtonText: intl.formatMessage({ id: "deleteDashboardDialog.submitButtonText" }) }, messages.map(function (message, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: message.id },
        index !== 0 && react_1.default.createElement("br", null),
        react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p" },
            react_1.default.createElement(react_intl_1.FormattedMessage, tslib_1.__assign({}, message))))); })));
};
//# sourceMappingURL=DefaultDeleteDialog.js.map